import React from "react";
import { bool, string } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** Visually hidden `<legend />` for fieldset */
  hideLegend: bool,
  /** Required `<legend />` for fieldset */
  legend: string.isRequired,
};

const CLASS_ROOT = "fieldset";

const Fieldset = ({ className, children, legend, hideLegend, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    { [`${CLASS_ROOT}--legend-hidden`]: hideLegend },
    className
  );

  return (
    <fieldset className={classes} {...other}>
      {legend && <legend>{legend}</legend>}
      {children}
    </fieldset>
  );
};

Fieldset.displayName = "Fieldset";
Fieldset.propTypes = propTypes;

export default Fieldset;
